import { useState } from "react";
import styles from "./styles.module.css";
import axios from "axios";

const Signup = ({ onSwitchToLogin }) => {
  const [data, setData] = useState({
    firstName: "", lastName: "", email: "", password: "",
  });
  const [error, setError] = useState("");

  const handleChange = ({ currentTarget: input }) => {
    const { name, value } = input;
    let sanitizedValue = value;
    if (name === "firstName" || name === "lastName")
      sanitizedValue = value.replace(/[^a-zA-ZąćęłńóśźżĄĆĘŁŃÓŚŹŻ\s-]/g, "").slice(0, 30);
    if (name === "email") sanitizedValue = value.trim();
    if (name === "password") sanitizedValue = value.slice(0, 64);
    setData({ ...data, [name]: sanitizedValue });
    setError("");
  };

  const validateData = () => {
    const { firstName, lastName, email, password } = data;
    if (!firstName || firstName.length < 2) return "Imię musi zawierać co najmniej 2 litery.";
    if (!lastName || lastName.length < 2) return "Nazwisko musi zawierać co najmniej 2 litery.";
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) return "Nieprawidłowy format adresu e-mail.";
    if (password.length < 6) return "Hasło musi mieć co najmniej 6 znaków.";
    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationError = validateData();
    if (validationError) {
      setError(validationError);
      return;
    }
    try {
      const url = `${process.env.REACT_APP_DEV_SERVER}/users`;
      await axios.post(url, data);
      if (onSwitchToLogin) onSwitchToLogin();
    } catch (error) {
      if (
        error.response &&
        error.response.status >= 400 &&
        error.response.status <= 500
      ) {
        setError(error.response.data.message);
      }
    }
  };

  return (
    <>
      <div className={styles.glass_logo_circle}>
        <img src="/logo192.png" alt="logo" />
      </div>
      <h2 className={styles.glass_modal_title}>Utwórz konto</h2>
      <form className={styles.glass_form} onSubmit={handleSubmit}>
        <div className={styles.glass_input_wrap}>
          <span className={styles.glass_input_icon}>
            <svg width="22" height="22"><circle cx="11" cy="10" r="6"/><ellipse cx="11" cy="18" rx="7" ry="3"/></svg>
          </span>
          <input
            type="text"
            placeholder="Imię"
            name="firstName"
            onChange={handleChange}
            value={data.firstName}
            required
            className={styles.glass_input}
            autoComplete="given-name"
          />
        </div>
        <div className={styles.glass_input_wrap}>
          <span className={styles.glass_input_icon}>
            <svg width="22" height="22"><circle cx="11" cy="10" r="6"/><ellipse cx="11" cy="18" rx="7" ry="3"/></svg>
          </span>
          <input
            type="text"
            placeholder="Nazwisko"
            name="lastName"
            onChange={handleChange}
            value={data.lastName}
            required
            className={styles.glass_input}
            autoComplete="family-name"
          />
        </div>
        <div className={styles.glass_input_wrap}>
          <span className={styles.glass_input_icon}>
            <svg width="22" height="22"><circle cx="11" cy="10" r="6"/><ellipse cx="11" cy="18" rx="7" ry="3"/></svg>
          </span>
          <input
            type="email"
            placeholder="Email"
            name="email"
            onChange={handleChange}
            value={data.email}
            required
            className={styles.glass_input}
            autoComplete="email"
          />
        </div>
        <div className={styles.glass_input_wrap}>
          <span className={styles.glass_input_icon}>
            <svg width="22" height="22"><rect x="6" y="11" width="10" height="7" rx="3.5"/><circle cx="11" cy="14.5" r="1.4"/></svg>
          </span>
          <input
            type="password"
            placeholder="Hasło"
            name="password"
            onChange={handleChange}
            value={data.password}
            required
            className={styles.glass_input}
            autoComplete="new-password"
          />
        </div>
        {error && <div className={styles.glass_error}>{error}</div>}
        <button type="submit" className={styles.glass_login_btn}>Zarejestruj</button>
      </form>
      <div className={styles.glass_bottom_row}>
        <span>Masz już konto?</span>
        <button type="button" className={styles.glass_link_btn} onClick={onSwitchToLogin}>Zaloguj się</button>
      </div>
    </>
  );
};

export default Signup;
